import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useDeleteExpense = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (id: string) => {
      // First delete expense documents
      const { error: docsError } = await supabase
        .from('expense_documents')
        .delete()
        .eq('expense_id', id);
      
      if (docsError) {
        console.error('Failed to delete expense documents:', docsError);
      }
      
      // Delete the expense (payment_request remains intact) - request returning rows so we can verify
      const { data: deleted, error: deleteError } = await supabase
        .from('expenses')
        .delete()
        .eq('id', id)
        .select('id');
      
      if (deleteError) {
        throw new Error(`Failed to delete expense: ${deleteError.message}`);
      }
      
      if (!deleted || deleted.length === 0) {
        throw new Error('Expense could not be deleted. You may not have permission to delete this expense.');
      }
      
      return { success: true };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expenses'] });
      queryClient.invalidateQueries({ queryKey: ['expense-stats'] });
      toast.success('Expense deleted');
    },
    onError: (error: Error) => {
      toast.error(`Failed to delete expense: ${error.message}`);
    },
  });
};
